import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchInventoryItemTagsOptions,
  fetchInventoryPackageTagsOptions,
  fetchInventoryItemAvailabilityLocationZoneOptions,
  fetchInventoryPackageAvailabilityLocationOptions,
  fetchTrackingMethodOptions
} from '../../../sagas/routines';

const initialState = {
  itemTags: {
    options: [],
    fetching: false,
    fetched: false,
    fetchingError: false
  },
  packageTags: {
    options: [],
    fetching: false,
    fetched: false,
    fetchingError: false
  },
  itemAvailabilityLocationZones: {
    options: [],
    fetching: false,
    fetched: false,
    fetchingError: false
  },
  packageAvailabilityLocations: {
    options: [],
    fetching: false,
    fetched: false,
    fetchingError: false
  },
  trackingMethods: {
    options: [],
    fetching: false,
    fetched: false,
    fetchingError: false
  }
};

const fetchItemTagsOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    itemTags: {
      ...state.itemTags,
      fetching: true,
      fetched: false
    }
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('itemTags.options', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    itemTags: {
      ...state.itemTags,
      fetching: false,
      fetched: true
    }
  })
});

const fetchPackageTagsOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    packageTags: {
      ...state.packageTags,
      fetching: true,
      fetched: false
    }
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('packageTags.options', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    packageTags: {
      ...state.packageTags,
      fetching: false,
      fetched: true
    }
  })
});

const fetchItemAvailabilityLocationZoneOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    itemAvailabilityLocationZones: {
      ...state.packageTags,
      fetching: true,
      fetched: false
    }
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('itemAvailabilityLocationZones.options', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    itemAvailabilityLocationZones: {
      ...state.itemAvailabilityLocationZones,
      fetching: false,
      fetched: true
    }
  })
});

const fetchPackageAvailabilityLocationOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    packageAvailabilityLocations: {
      ...state.packageTags,
      fetching: true,
      fetched: false
    }
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('packageAvailabilityLocations.options', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    packageAvailabilityLocations: {
      ...state.packageAvailabilityLocations,
      fetching: false,
      fetched: true
    }
  })
});

const fetchTrackingMethodOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    trackingMethods: {
      ...state.trackingMethods,
      fetching: true,
      fetched: false
    }
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('trackingMethods.options', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    trackingMethods: {
      ...state.trackingMethods,
      fetching: false,
      fetched: true
    }
  })
});

export default createReducer(initialState, {
  ...fetchItemTagsOptionsHandler(fetchInventoryItemTagsOptions),
  ...fetchPackageTagsOptionsHandler(fetchInventoryPackageTagsOptions),
  ...fetchItemAvailabilityLocationZoneOptionsHandler(
    fetchInventoryItemAvailabilityLocationZoneOptions
  ),
  ...fetchPackageAvailabilityLocationOptionsHandler(
    fetchInventoryPackageAvailabilityLocationOptions
  ),
  ...fetchTrackingMethodOptionsHandler(fetchTrackingMethodOptions)
});
